module.exports = __webpack_public_path__ + "img/plan.0712f2fe.png";